import { WaitlistForm } from "./WaitlistForm";

export function FinalCTA() {
  return (
    <section className="final" id="waitlist">
      <div className="container final-content">
        <h2>Stop doing books.<br />Start doing <em>business.</em></h2>
        <p>The first 100 teams pay nothing for their first year. Connect Revolut, EBICS, or Stripe in two minutes and watch your books reconcile themselves.</p>

        <WaitlistForm variant="final" />

        <div style={{ marginTop: "24px", fontFamily: "'JetBrains Mono', monospace", fontSize: "11px", color: "rgba(244,239,230,0.5)", letterSpacing: "0.1em" }}>
          - NO SPAM - NO DEMOS - JUST AN INVITE WHEN WE'RE READY -
        </div>
      </div>
    </section>
  );
}
